export default "__VITE_ASSET__BjCsRELa__"